import React, { useState, useEffect } from 'react';
import useInputKeys from 'hooks/useInputKeys';
import './index.scss';

function Bare() {
  const { currentBare } = useInputKeys();
  const [numbers, setNumbers] = useState(['0', '0']);

  useEffect(() => {
    const newNumbers = `0${currentBare}`.slice(-2).split("");
    setNumbers(newNumbers);
  }, [currentBare]);

  return (
    <div className="bare-wrapper">
      {numbers.map((number, index) => (
        <div key={index}>{number}</div>
      ))}
    </div>
  );
}

export default Bare;

